'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ImportFromURLIntl = exports.InputFileValidationStateIntl = exports.ImportFromURL = exports.ActionLabel = exports.InputFileDnDDropTarget = exports.InputFileDnD = exports.InputFileValidationState = exports.InputFile = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDndHtml5Backend = require('react-dnd-html5-backend');

var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);

var _reactDnd = require('react-dnd');

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _reactBootstrap = require('react-bootstrap');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _accessibilityUtils = require('./accessibilityUtils');

var _ContentLoading = require('./ContentLoading');

var _ContentLoading2 = _interopRequireDefault(_ContentLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Note react dnd slices the DataTransfer FileList making it impossible for us to attempt to
// update the hidden input. This may limit the useful ness of this component in complex forms.

var fileTarget = {
	drop: function drop(props, monitor, component) {
		component.getWrappedInstance().onFileSelect(monitor.getItem().files);
	}
	// Ideally we'd count the files in canDrop and enforce single file
	// restriction here (but we cant't).
	// "Browser doesn't allow reading "files" until the drop event."

};

var collect = function collect(connect, monitor) {
	return {
		connectDropTarget: connect.dropTarget(),
		isOver: monitor.isOver(),
		canDrop: monitor.canDrop(),
		itemType: monitor.getItemType()
	};
};

/**
 * A form control for file input that supports drag and drop, url
 * or regular file selection.
 */
var InputFile = exports.InputFile = function InputFile(props) {
	return _react2.default.createElement(
		'div',
		{ className: (0, _classnames2.default)('input-file', props.className) },
		props.loading && _react2.default.createElement(_ContentLoading2.default, null),
		props.validationState && props.validationState.severity && _react2.default.createElement(InputFileValidationStateIntl, {
			onOkay: props.onValidationStateOkay,
			onOkayText: props.onValidationStateOkayText,
			validationState: props.validationState
		}),
		_react2.default.createElement(InputFileDnDDropTarget, props)
	);
};

InputFile.propTypes = {
	loading: _propTypes2.default.bool,
	validationState: _propTypes2.default.oneOfType([
	// Generic validation - will be displayed in a panel.
	_propTypes2.default.shape({
		severity: _propTypes2.default.oneOf(['success', 'warning', 'error']).isRequired,
		title: _propTypes2.default.string,
		message: _propTypes2.default.string
	}),
	// Field validation state.
	_propTypes2.default.shape({
		url: {
			severity: _propTypes2.default.oneOf(['success', 'warning', 'error']).isRequired,
			message: _propTypes2.default.string
		}
	})]),
	onValidationStateOkay: _propTypes2.default.func,
	onValidationStateOkayText: _propTypes2.default.string,
	name: _propTypes2.default.string,
	className: _propTypes2.default.string,
	dropzoneIcon: _propTypes2.default.string,
	dropHereText: _propTypes2.default.string,
	accept: _propTypes2.default.string,
	multiple: _propTypes2.default.bool,
	labelText: _propTypes2.default.string,
	onFileSelect: _propTypes2.default.func.isRequired,
	onUrlSelect: _propTypes2.default.func
};

/**
 * Display the validation state of the upload.
 */

var InputFileValidationState = exports.InputFileValidationState = function (_React$Component) {
	_inherits(InputFileValidationState, _React$Component);

	function InputFileValidationState(props) {
		_classCallCheck(this, InputFileValidationState);

		var _this = _possibleConstructorReturn(this, (InputFileValidationState.__proto__ || Object.getPrototypeOf(InputFileValidationState)).call(this, props));

		_axwayReactIntl2.default.init(_this);
		_this.onOkayText = _this.props.onOkayText || _this.intl.formatMsg('Retry Upload');
		return _this;
	}

	_createClass(InputFileValidationState, [{
		key: 'render',
		value: function render() {
			var validationState = this.props.validationState;

			var icon = void 0;
			if (validationState.severity === 'error') {
				icon = ' gg icon-GG-cross-circle';
			} else if (validationState.severity === 'success') {
				icon = ' gg icon-GG-checkmark-circle';
			} else {
				icon = ' gg icon-GG-warning';
			}
			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)('validation', validationState.severity) },
				_react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: icon }),
				_react2.default.createElement(
					'div',
					{ className: 'detail' },
					_react2.default.createElement(
						'div',
						{ className: 'title' },
						validationState.title
					),
					_react2.default.createElement(
						'div',
						{ className: 'message' },
						validationState.message
					)
				),
				this.props.onOkay && _react2.default.createElement(
					_reactBootstrap.Button,
					{
						bsStyle: 'primary',
						bsSize: 'large',
						onClick: this.props.onOkay
					},
					this.onOkayText
				)
			);
		}
	}]);

	return InputFileValidationState;
}(_react2.default.Component);

InputFileValidationState.propTypes = {
	validationState: _propTypes2.default.shape({
		severity: _propTypes2.default.oneOf(['success', 'warning', 'error']).isRequired,
		title: _propTypes2.default.string,
		message: _propTypes2.default.string
	}).isRequired,
	onOkay: _propTypes2.default.func,
	onOkayText: _propTypes2.default.string
};

/**
 * A form control for file input that supports drag and drop, url
 * or regular file selection.
 */

var InputFileDnD = exports.InputFileDnD = function (_React$Component2) {
	_inherits(InputFileDnD, _React$Component2);

	function InputFileDnD(props) {
		_classCallCheck(this, InputFileDnD);

		var _this2 = _possibleConstructorReturn(this, (InputFileDnD.__proto__ || Object.getPrototypeOf(InputFileDnD)).call(this, props));

		_axwayReactIntl2.default.init(_this2);
		_this2.onFileSelect = _this2.onFileSelect.bind(_this2);
		_this2.dropActionText = props.dropActionText || _this2.intl.formatMsg('Drag and drop your file, |browse| for files');
		_this2.dropHereText = props.dropHereText || _this2.intl.formatMsg('Drag and drop your file here');
		return _this2;
	}

	_createClass(InputFileDnD, [{
		key: 'onFileSelect',
		value: function onFileSelect(files) {
			var multiple = this.props.multiple;

			if (!multiple && files.length === 1) {
				this.props.onFileSelect(files[0]);
			} else {
				this.props.onFileSelect(files);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    className = _props.className,
			    dropzoneIcon = _props.dropzoneIcon,
			    accept = _props.accept,
			    multiple = _props.multiple,
			    name = _props.name,
			    onUrlSelect = _props.onUrlSelect,
			    isOver = _props.isOver,
			    canDrop = _props.canDrop,
			    connectDropTarget = _props.connectDropTarget,
			    url = _props.url,
			    validationState = _props.validationState;


			return connectDropTarget(_react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)('input-file-dnd', className, { 'is-over': isOver, 'can-drop': canDrop }) },
				_react2.default.createElement(
					'div',
					{ className: 'file-dropzone' },
					_react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: dropzoneIcon })
				),
				_react2.default.createElement(
					'div',
					{ className: 'file-action' },
					canDrop && _react2.default.createElement(
						'div',
						{ className: 'action-dragging' },
						this.dropHereText
					),
					!canDrop && _react2.default.createElement(ActionLabel, {
						name: name,
						accept: accept,
						multiple: multiple,
						labelText: this.dropActionText,
						onSelect: this.onFileSelect
					})
				),
				onUrlSelect && _react2.default.createElement(
					'div',
					{ className: 'file-url' },
					_react2.default.createElement(
						'div',
						{ className: 'url-label' },
						this.intl.formatMsg('or')
					),
					_react2.default.createElement(ImportFromURLIntl, {
						value: url,
						validationState: validationState && validationState.url,
						onSelect: onUrlSelect
					})
				)
			));
		}
	}]);

	return InputFileDnD;
}(_react2.default.Component);

InputFileDnD.propTypes = {
	name: _propTypes2.default.string,
	className: _propTypes2.default.string,
	dropzoneIcon: _propTypes2.default.string,
	dropActionText: _propTypes2.default.string,
	dropHereText: _propTypes2.default.string,
	accept: _propTypes2.default.string,
	multiple: _propTypes2.default.bool,
	onFileSelect: _propTypes2.default.func.isRequired,
	onUrlSelect: _propTypes2.default.func
};

InputFileDnD.defaultProps = {
	name: 'file',
	dropzoneIcon: ' gg icon-GG-files'
};

var InputFileDnDDropTarget = exports.InputFileDnDDropTarget = (0, _reactDnd.DropTarget)(_reactDndHtml5Backend.NativeTypes.FILE, fileTarget, collect)((0, _reactIntl.injectIntl)(InputFileDnD, { withRef: true }));

/**
 * Label with the action to perform.
 */

var ActionLabel = exports.ActionLabel = function (_React$Component3) {
	_inherits(ActionLabel, _React$Component3);

	function ActionLabel(props) {
		_classCallCheck(this, ActionLabel);

		var _this3 = _possibleConstructorReturn(this, (ActionLabel.__proto__ || Object.getPrototypeOf(ActionLabel)).call(this, props));

		_this3.onAction = _this3.onAction.bind(_this3);
		_this3.onChange = _this3.onChange.bind(_this3);
		return _this3;
	}

	_createClass(ActionLabel, [{
		key: 'onAction',
		value: function onAction(e) {
			e.preventDefault();
			e.stopPropagation();
			this.inputEl && this.inputEl.click();
		}
	}, {
		key: 'onChange',
		value: function onChange() {
			var files = this.inputEl.files && this.inputEl.files;
			this.props.onSelect && this.props.onSelect(files);
			this.inputEl.value = null;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this4 = this;

			var _props2 = this.props,
			    accept = _props2.accept,
			    labelText = _props2.labelText,
			    multiple = _props2.multiple,
			    name = _props2.name;

			var lblTemplate = [labelText, '', ''];

			if (this.props.onSelect) {
				// Can be manually selected - identify link placeholder in label |between pipes|
				labelText.replace(/(.*?)(\|.+?\|)(.*)/, function (m, p1, p2, p3) {
					lblTemplate[0] = p1 || '';
					lblTemplate[1] = p2 ? p2.substring(1, p2.length - 1) : '';
					lblTemplate[2] = p3 || '';
				});
			}

			return _react2.default.createElement(
				'span',
				{ className: 'action-label' },
				_react2.default.createElement(
					'span',
					{ className: 'text' },
					lblTemplate[0],
					lblTemplate[1] && _react2.default.createElement(
						'a',
						{
							tabIndex: 0,
							onKeyPress: function onKeyPress(e) {
								return (0, _accessibilityUtils.OnActionKey)(e, _this4.onAction);
							},
							onClick: this.onAction
						},
						lblTemplate[1]
					),
					lblTemplate[2]
				),
				this.props.onSelect && _react2.default.createElement('input', {
					ref: function ref(r) {
						_this4.inputEl = r;
					},
					type: 'file',
					accept: accept,
					onChange: this.onChange,
					id: name,
					multiple: multiple
				})
			);
		}
	}]);

	return ActionLabel;
}(_react2.default.Component);

ActionLabel.propTypes = {
	/**
  * The name of the form input.
  */
	name: _propTypes2.default.string.isRequired,

	/**
  * The file extension.
  */
	accept: _propTypes2.default.string,

	/**
  * Allow multiple selection.
  */
	multiple: _propTypes2.default.bool,

	/**
  * The label text is expected to have a placeholder in |'s, e.g.
  *'|browse|' which will be replaced with a link.
  */
	labelText: _propTypes2.default.string.isRequired,

	/**
  * File selected.
  */
	onSelect: _propTypes2.default.func
};

ActionLabel.defaultProps = {
	multiple: false
};

/**
 * File download from URL.
 */

var ImportFromURL = exports.ImportFromURL = function (_React$Component4) {
	_inherits(ImportFromURL, _React$Component4);

	function ImportFromURL(props) {
		_classCallCheck(this, ImportFromURL);

		var _this5 = _possibleConstructorReturn(this, (ImportFromURL.__proto__ || Object.getPrototypeOf(ImportFromURL)).call(this, props));

		_axwayReactIntl2.default.init(_this5);
		_this5.onSelect = _this5.onSelect.bind(_this5);
		return _this5;
	}

	_createClass(ImportFromURL, [{
		key: 'onSelect',
		value: function onSelect() {
			this.props.onSelect && this.props.onSelect(this.urlInputEl.value);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this6 = this;

			var _props3 = this.props,
			    placeholder = _props3.placeholder,
			    value = _props3.value,
			    validationState = _props3.validationState;


			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					_reactBootstrap.FormGroup,
					{ validationState: validationState && validationState.severity },
					_react2.default.createElement(
						_reactBootstrap.InputGroup,
						{ bsSize: 'large', className: (0, _classnames2.default)(validationState && validationState.severity) },
						_react2.default.createElement(_reactBootstrap.FormControl, {
							inputRef: function inputRef(ref) {
								_this6.urlInputEl = ref;
							},
							defaultValue: value,
							type: 'text',
							placeholder: placeholder,
							autoFocus: true
						}),
						_react2.default.createElement(
							_reactBootstrap.InputGroup.Button,
							null,
							_react2.default.createElement(
								_reactBootstrap.Button,
								{
									bsStyle: 'primary',
									bsSize: 'large',
									onClick: this.onSelect
								},
								this.intl.formatMsg('Fetch from URL')
							)
						)
					),
					validationState && _react2.default.createElement(
						_reactBootstrap.HelpBlock,
						null,
						validationState.message
					)
				)
			);
		}
	}]);

	return ImportFromURL;
}(_react2.default.Component);

ImportFromURL.propTypes = {
	validationState: _propTypes2.default.object,
	value: _propTypes2.default.string,
	placeholder: _propTypes2.default.string
};

ImportFromURL.defaultProps = {
	placeholder: 'http://'
};

var InputFileValidationStateIntl = exports.InputFileValidationStateIntl = (0, _reactIntl.injectIntl)(InputFileValidationState);
var ImportFromURLIntl = exports.ImportFromURLIntl = (0, _reactIntl.injectIntl)(ImportFromURL);

var _default = (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend2.default)(InputFile);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(fileTarget, 'fileTarget', 'src/components/InputFile.jsx');

	__REACT_HOT_LOADER__.register(collect, 'collect', 'src/components/InputFile.jsx');

	__REACT_HOT_LOADER__.register(InputFile, 'InputFile', 'src/components/InputFile.jsx');

	__REACT_HOT_LOADER__.register(InputFileValidationState, 'InputFileValidationState', 'src/components/InputFile.jsx');

	__REACT_HOT_LOADER__.register(InputFileDnD, 'InputFileDnD', 'src/components/InputFile.jsx');

	__REACT_HOT_LOADER__.register(InputFileDnDDropTarget, 'InputFileDnDDropTarget', 'src/components/InputFile.jsx');

	__REACT_HOT_LOADER__.register(ActionLabel, 'ActionLabel', 'src/components/InputFile.jsx');

	__REACT_HOT_LOADER__.register(ImportFromURL, 'ImportFromURL', 'src/components/InputFile.jsx');

	__REACT_HOT_LOADER__.register(InputFileValidationStateIntl, 'InputFileValidationStateIntl', 'src/components/InputFile.jsx');

	__REACT_HOT_LOADER__.register(ImportFromURLIntl, 'ImportFromURLIntl', 'src/components/InputFile.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/InputFile.jsx');
}();

;